// extracted by mini-css-extract-plugin
export default {"fill-placeholder-child":"fill-placeholder-child_y7qO0","modal-wrap":"modal-wrap_Bjwcn","title-img":"title-img_gpjqA"};